import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Copyright' })((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
      width: '100%',
    },
  },
  brandMark: {
    display: 'block',
    flexShrink: 0,
  },
  copyrightText: {
    color: theme.palette.custom.grey.main,
    fontSize: theme.typography.pxToRem(13),
    paddingLeft: theme.spacing(1),
  },
}));
